module.exports = __webpack_public_path__ + "static/media/YF77_6.31930f1e.jpg";